const tzBatch = () => import("@/pages/tz/tzBatch/tzBatch.vue");
const tzBatchInfo = () => import("@/pages/tz/tzBatchInfo/tzBatchInfo.vue");
const tzCarcass = () => import("@/pages/tz/tzCarcass/tzCarcass.vue");
const tzSales = () => import("@/pages/tz/tzSales/tzSales.vue");
const tzAbattpir = () => import("@/pages/tz/tzAbattpir/tzAbattpir.vue");
const tzBatchAudit = () => import("@/pages/tz/tzBatchAudit/tzBatchAudit.vue");
const tzDetail = () => import("@/pages/tz/tzDetail/tzDetail.vue");
export default [
  {
    path: "/tz/tzBatch",
    name: "tzBatch",
    component: tzBatch,
    meta: {
      title: "屠宰批次",
      noCache: true,
      affix: true,
      path: ["屠宰管理", "屠宰批次"]
    }
  },{
    path: "/tz/tzBatchAudit",
    name: "tzBatchAudit",
    component: tzBatchAudit,
    meta: {
      title: "屠宰审核",
      noCache: true,
      affix: true,
      path: ["屠宰管理", "屠宰审核"]
    }
  },
  {
    path: "/tz/tzCarcass",
    name: "tzCarcass",
    component: tzCarcass,
    meta: {
      title: "胴体数据",
      noCache: true,
      affix: true,
      path: ["屠宰管理", "胴体数据"]
    },
  },
  {
    path: "/tz/tzBatchInfo",
    name: "tzBatchInfo",
    component: tzBatchInfo,
    meta: {
      title: "屠宰批次信息",
      noCache: true,
      affix: true,
      path: ["屠宰管理", "屠宰批次信息"]
    },
  },
  {
    path: "/tz/tzSales",
    name: "tzSales",
    component: tzSales,
    meta: {
      title: "销售登记",
      noCache: true,
      affix: true,
      path: ["屠宰管理", "销售登记"]
    },
  },
  {
    path: "/tz/tzAbattpir",
    name: "tzAbattpir",
    component: tzAbattpir,
    meta: {
      title: "屠宰场信息",
      noCache: true,
      affix: true,
      path: ["屠宰管理", "屠宰场信息"]
    },
  },
  {
    path: "/tz/tzDetail",
    name: "tzDetail",
    component: tzDetail,
    meta: {
      title: "屠宰管理",
      noCache: true,
      affix: true,
      path: ["屠宰管理", "屠宰管理"]
    },
  }
];



// WEBPACK FOOTER //
// ./src/router/tzInfo.js